// extracted by mini-css-extract-plugin
module.exports = {"container":"RatingGrid_container__1_kN3","group":"RatingGrid_group__24nuZ"};